import clsx from 'clsx';
import React from 'react';

import { Button } from '@/components/button/button';
import { FriendlyError } from '@/components/friendlyError/friendlyError';
import { friendlyPulumiError } from '@/utils/friendlyPulumiError';

import styles from '../../contractDetails.module.scss';

interface LatestTask {
  task_id: string;
  task_type: string;
  error?: string | null;
  started_at?: string | null;
}

interface ErrorDetailsProps {
  error?: string | null;
  latestTask?: LatestTask | null;
  contractName: string;
  contractId: string;
  isExpanded: boolean;
  onToggleExpand: () => void;
}

export function ErrorDetails( {
  error,
  latestTask,
  contractName,
  contractId,
  isExpanded,
  onToggleExpand
}: ErrorDetailsProps ) {
  // FriendlyError owns its own raw-log disclosure, so the parent truncate
  // toggle is redundant when a friendly view is rendered.
  const hasFriendly = !!friendlyPulumiError( error );

  return (
    <div className={ styles.errorColumn }>
      <div className={ styles.errorDetailsSection }>
        <div className={ styles.subsectionHeader }>
          <h4>Error Details</h4>
          { error && !hasFriendly && (
            <Button
              variant='secondary'
              size='sm'
              onClick={ onToggleExpand }
              data-testid='toggle-error-button'
            >
              Error Message
            </Button>
          ) }
        </div>
        { error ? (
          <>
            <div
              className={ clsx( styles.errorMessage, { [styles.errorMessageTruncated]: !hasFriendly && !isExpanded } ) }
              data-testid='error-details-message'
            >
              <FriendlyError error={ error } />
            </div>
            { latestTask && (
              <div className={ styles.taskInfo }>
                <strong>Task ID:</strong> { latestTask.task_id }<br />
                <strong>Type:</strong> { latestTask.task_type }<br />
                <strong>Name:</strong> { contractName }<br />
                <strong>Contract:</strong> { contractId }<br />
                <strong>Created:</strong> { latestTask.started_at
                  ? new Date( latestTask.started_at ).toLocaleString()
                  : 'N/A' }
              </div>
            ) }
          </>
        ) : (
          <p className={ styles.statusDescription }>No error details available.</p>
        ) }
      </div>
    </div>
  );
}
